/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("ScrollAreaController", ["ControllerBase", "ControllerFactory"], function (context, cls) {
  /**
   * @class ScrollAreaController
   * @memberOf classes
   * @extends classes.ControllerBase
   */
  class ScrollAreaController extends cls.ControllerBase /** @lends classes.ScrollAreaController.prototype */ {
    static __name = "ScrollAreaController";

    _initBehaviors() {
      super._initBehaviors();

      // These behaviors should stay added at first
      // WARNING : DO NOT ADD BEHAVIORS BEFORE
      this._addBehavior(cls.LayoutInfoVMBehavior);
      // END WARNING

      // 4st behaviors
      this._addBehavior(cls.Reverse4STBehavior);
      this._addBehavior(cls.ThinScrollBarDisplayTime4STBehavior);

      // vm behaviors
      this._addBehavior(cls.EnabledVMBehavior);
      this._addBehavior(cls.ScrollVMBehavior);
      this._addBehavior(cls.CurrentRowVMBehavior);

      // ui behaviors
      this._addBehavior(cls.ScrollUIBehavior);
    }

    /**
     * @inheritDoc
     */
    sendWidgetValue(newValue = null) {
      const ui = this.getUINode();
      const focusedNode = ui.getApplication().getNode(ui.attribute("focus"));
      const focusedWidgetController = focusedNode.getController();
      focusedWidgetController.sendWidgetValue(newValue);
    }

    /**
     * @returns {number} the current row of the scrollgrid node
     */
    getCurrentRow() {
      return this.getAnchorNode().attribute("currentRow");
    }

    getOffset() {
      return this.getAnchorNode().attribute("offset");
    }
  }

  cls.ScrollAreaController = ScrollAreaController;
  cls.ControllerFactory.register("ScrollArea", cls.ScrollAreaController);
});
